module.exports = __webpack_public_path__ + "assets/clients-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/clients-icon.png
// module id = 1220
// module chunks = 7